"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeDotButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
function ThreeDotButton(props) {
    const { disabled, tooltipContext, isOpen, tooltipPlace, onClick, tooltipOnForTouchDevice, isSelected = false, } = props;
    return ((0, jsx_runtime_1.jsx)(TooltipButton, Object.assign({}, props, { tooltip: {
            context: tooltipContext,
            place: tooltipPlace || 'right',
            isTouchDeviceAvailable: tooltipOnForTouchDevice,
            isOpen: isOpen,
            openOnClick: true,
            styles: {
                backgroundColor: (0, ui_1.getTheme)().grasshopper.spotsPanel.selectedBackground,
            },
        }, onClick: onClick, disabled: disabled, isSelected: isSelected || isOpen, "$flashOnClick": true, "data-e2e": 'ThreeDotButton_TooltipButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Three_Dot_Vertical, width: 24, height: 24, "data-e2e": 'ThreeDotButton_Icon' }) })));
}
exports.ThreeDotButton = ThreeDotButton;
const TooltipButton = (0, ui_1.withTooltip)(ui_1.ToolBarBaseButton);
